import React, { Component } from 'react';
import { ActionIDs } from "../../../GenericWebController/ActionGraph/ActionIDs/ActionIDs"
import Actions from "../../../GenericWebController/ActionGraph/Actions"
import { DebugAlert, Class, Interface, Abstract, ObjectTypes, JSTypeOperator, cListForBase } from "../../../GenericCoreGraph/ClassFramework/Class"
import TObject from "../../../TagComponents/TObject"
import GenericWebGraph from "../../../GenericWebController/GenericWebGraph"
import { CommandInterfaces } from "../../../GenericWebController/CommandInterpreter/cCommandInterpreter"
import { CommandIDs } from "../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs"

import { withStyles } from '@material-ui/core/styles';
import BigCalendarStyles from "../../../../ScriptStyles/BigCalendarStyles"
import classNames from "classnames"

import { func } from 'prop-types';


var TBigCalenderTimeHeader = Class( TObject,

  {
    ObjectType: ObjectTypes.Get( "TBigCalenderTimeHeader" )
    ,
    constructor: function ( _Props )
    {
      TBigCalenderTimeHeader.BaseObject.constructor.call( this, _Props );
      this.state =
      {
        ...this.state
      }
    }
    ,
    Destroy: function ()
    {
      TBigCalenderTimeHeader.BaseObject.Destroy.call( this );
    }
    ,
    HandleGetBoxProps: function ()
    {
      const { classes } = this.props;
      if (this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow)
      {
        return classes.miniTimeBox;
      }
      else
      {
        return classes.timeBox;
      }
    }
    ,
    render: function ()
    {
      const { classes } = this.props;
      return (
        <div className={classNames(this.HandleGetBoxProps())}>{this.props.text}</div>
      );
    }
  }, {} );

export default withStyles(BigCalendarStyles)(TBigCalenderTimeHeader);
